import React from "react";
import { Route } from "react-router-dom";
import LoginBlock from "../components/dumb/LoginBlock";
import useModal from "../hook/useModal";
import { login } from "../redux/ducks/session";
import useStatusThunk from "../hook/useStatusThunk";
import useAuthEffect from "../hook/useAuthEffect";

const PrivateRoute = ({ component: Component, ...rest }) => {

    const [d_login, status, error] = useStatusThunk(login);
    const [show, hide, renderModal] = useModal(false);

    useAuthEffect(isAuth => {
        if (isAuth) {
            hide();
        } else {
            show();
        }
    });

    const logIn = (userName, password) => d_login({ userName, password });

    return (
        <Route {...rest} render={props => (
            <React.Fragment>
                <Component {...props} />
                {renderModal(
                    <LoginBlock loading={status == "pending"} error={error} logIn={logIn} />
                )}
            </React.Fragment>
        )} />
    );
}

export default PrivateRoute;